<div *ngIf="ready" class="orders-container">
  <mat-card appearance="outlined" class="order-card">
    <mat-card-header>
      <mat-card-title>Pedidos</mat-card-title>
    </mat-card-header>

    <ng-container *ngIf="loading">
      <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </ng-container>

    <div class="row mb-2" style="display:flex; align-items:center; gap:12px; flex-wrap:wrap;">
      <button type="button" (click)="goCreate()" mat-stroked-button class="btn btn-warning btn-circle btn-lg p-0">
        <mat-icon class="mat-icon-add-custom">add</mat-icon>
      </button>

      <mat-checkbox [(ngModel)]="hideConfirmed" (change)="applyFilters()">
        Ocultar confirmados
      </mat-checkbox>

      <app-input inputType="text" placeholder="Nombre proveedor" [(ngModel)]="supplierFilter"
        (input)="applyFilters()"></app-input>

      <mat-form-field appearance="outline">
        <mat-label>Buscar por fecha</mat-label>
        <input matInput [matDatepicker]="picker" [(ngModel)]="dateFilter" (dateChange)="applyFilters()"
          placeholder="Selecciona fecha">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <button mat-button type="button" (click)="clearFilters()">Limpiar</button>
    </div>

    <div class="row mt-2">
      <mat-card-content style="width:100%;">
        <div class="order-table-container">
          <table mat-table [dataSource]="orderRows" class="mat-elevation-z2 full-width-table">

            <ng-container matColumnDef="orderDate">
              <th mat-header-cell *matHeaderCellDef style="background-color:var(--cf-brand); font-size:14px;"> Fecha </th>
              <td mat-cell *matCellDef="let row"> {{ row.orderDate | date:'shortDate' }} </td>
            </ng-container>

            <ng-container matColumnDef="orderNumber">
              <th mat-header-cell *matHeaderCellDef style="background-color:var(--cf-brand); font-size:14px;"> Número de pedido </th>
              <td mat-cell *matCellDef="let row"> {{ row.orderNumber }} </td>
            </ng-container>

            <ng-container matColumnDef="supplierName">
              <th mat-header-cell *matHeaderCellDef style="background-color:var(--cf-brand); font-size:14px;"> Proveedor </th>
              <td mat-cell *matCellDef="let row" (click)="goEdit(row.uid, true)" style="cursor:pointer">
                {{ row.supplierName }}
              </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef style="background-color:var(--cf-brand); font-size:14px;"> Estado </th>
              <td mat-cell *matCellDef="let row" (click)="confirmReception(row)" style="cursor:pointer">
                <span *ngIf="row.status === 0">Pendiente</span>
                <span *ngIf="row.status === 1">Confirmado</span>
                <span *ngIf="row.status !== 0 && row.status !== 1">Desconocido</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef style="background-color:var(--cf-brand); font-size:14px;"> Acciones </th>
              <td mat-cell *matCellDef="let row">
                <button mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>

                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="goEdit(row.uid, true)">
                    <mat-icon>visibility</mat-icon>
                    <span>Ver detalles</span>
                  </button>

                  <button mat-menu-item (click)="goEdit(row.uid, false)" *ngIf="row.status === 0">
                    <mat-icon>edit</mat-icon>
                    <span>Editar</span>
                  </button>

                  <button *ngIf="row.status === 0" mat-menu-item (click)="deleteOrder(row)">
                    <mat-icon>delete</mat-icon>
                    <span>Eliminar</span>
                  </button>

                  <button *ngIf="row.status === 0" mat-menu-item (click)="confirmReception(row)">
                    <mat-icon>check_circle</mat-icon>
                    <span>Confirmar recepción</span>
                  </button>

                  <button mat-menu-item (click)="duplicateOrder(row)">
                    <mat-icon>content_copy</mat-icon>
                    <span>Duplicar pedido</span>
                  </button>

                  <button mat-menu-item (click)="downloadPdf(row)">
                    <mat-icon>picture_as_pdf</mat-icon>
                    <span>Descargar PDF</span>
                  </button>

                  <button mat-menu-item (click)="downloadExcel(row)">
                    <mat-icon>grid_on</mat-icon>
                    <span>Descargar Excel</span>
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>
      </mat-card-content>
    </div>
  </mat-card>
</div>

<div *ngIf="!ready" class="loading-container">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</div>